export {};
//# sourceMappingURL=IFeatureOptIn.js.map